import { useEffect } from 'react'

import { useClientSideFeatureFlag } from 'modules/core/lib/clientSideFeatureFlags'

export const DarkModeExperimentalBodyClass = () => {
  const { isFeatureFlagEnabled } = useClientSideFeatureFlag()

  useEffect(() => {
    const isDarkModeEnabled = isFeatureFlagEnabled('dark-mode')

    if (isDarkModeEnabled) {
      document.body.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
    }

    return () => {
      document.body.classList.remove('dark')
    }
  }, [isFeatureFlagEnabled])

  return null
}
